"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAppointmentUiSchema = makeAppointmentUiSchema;
exports.makeAppointmentConflictsUiSchema = makeAppointmentConflictsUiSchema;
const domain_1 = require("@home-health-notify/domain");
function makeAppointmentUiSchema(field, label, params) {
    const { disablePast, disableFuture } = params;
    return {
        type: domain_1.RenderersUIType.AppointmentPicker,
        label,
        scope: `#/properties/${field}`,
        options: {
            disablePast: !!disablePast,
            disableFuture: !!disableFuture,
        },
    };
}
function makeAppointmentConflictsUiSchema(field) {
    return {
        type: "Control",
        label: "Allow Conflict",
        scope: `#/properties/${field}/properties/isConflictAllowed`,
        rule: {
            effect: "SHOW",
            condition: {
                scope: `#/properties/${field}/properties/isError`,
                schema: {
                    const: true,
                },
            },
        },
    };
}
